<template>
  <div>
    <b-card v-if="currentStep === 1" class="x-api-key-card">
      <div class="text-center">
        <div class="mb-1">
          <span class="text-color-grey text-size-12">Step 1 of 2</span>
        </div>
        <span class="d-block text-uppercase text-semibold-black text-size-24">
          Initial Settings
        </span>
        <span class="d-block text-uppercase text-semibold-black text-size-32">
          Enter
          <span class="text-semibold-primary">x-api-key</span>
        </span>
      </div>
      <div class="d-flex justify-content-center mt-1">
        <div v-if="!isFetchingSiteOption" class="custom-input-width">
          <atom-input
            v-model="xApiKey"
            title="X-API-KEY"
            :isAsterisk="true"
            :isError="!isValidXApiKey && !isFirstTimeEnterXApiKey"
            errorMessage="Please contact Admin to enter valid X-API-Key"
          ></atom-input>
        </div>
        <div v-else>
          <b-spinner variant="primary"></b-spinner>
        </div>
      </div>
      <div class="d-flex justify-content-center mt-3">
        <div class="custom-btn-width">
          <atom-button
            buttonId="save-key-btn"
            :isDisable="isFetchingSiteOption"
            @click="clickSaveXApiKey"
          >
            Next
          </atom-button>
        </div>
      </div>
    </b-card>

    <b-card v-else class="select-site-location-card">
      <div class="text-center">
        <div class="mb-1">
          <span class="text-color-grey text-size-12">Step 2 of 2</span>
        </div>
        <span class="d-block text-uppercase text-semibold-black text-size-24">
          Initial Settings
        </span>
        <span class="d-block text-uppercase text-semibold-black text-size-32">
          Choose
          <span class="text-semibold-primary">Site Location</span>
        </span>
      </div>
      <div class="d-flex justify-content-center mt-1">
        <div class="custom-site-list-width">
          <span class="d-block text-size-12">
            Location<span class="text-color-danger">*</span>
          </span>
          <div class="site-option-container">
            <div
              v-for="(site, index) of siteOption"
              :key="index"
              class="site-option-card"
              :class="{
                'site-option-card--active': site.siteId === selectedSiteId,
              }"
              @click="selectedSiteId = site.siteId"
            >
              {{ site.siteName }}
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-center mt-2">
        <atom-button
          buttonId="back-btn"
          buttonStyle="border"
          buttonColor="secondary"
          @click="clickBackToSetXApiKey"
        >
          Back
        </atom-button>
        <atom-button
          buttonId="confirm-setup-btn"
          class="ml-1"
          :isDisable="!selectedSiteId"
          @click="clickSelectSite"
        >
          Confirm
        </atom-button>
      </div>
    </b-card>
  </div>
</template>

<script>
import { BCard, BSpinner } from "bootstrap-vue"
import AtomButton from "@/components/atoms/AtomButton.vue"
import AtomInput from "@/components/atoms/AtomInput.vue"
export default {
  name: "MoleculeSetupLocalStorageCard",
  components: {
    BCard,
    BSpinner,
    AtomButton,
    AtomInput,
  },
  props: {
    isValidXApiKey: {
      type: Boolean,
      required: true,
    },
    isFetchingSiteOption: {
      type: Boolean,
      required: true,
    },
    siteOption: {
      type: Array,
      required: true,
    },
  },
  emits: ["onSaveXApiKeyToLocalStorage", "onSaveSelectedSiteIdToLocalStorage"],

  data() {
    return {
      xApiKey: "",
      selectedSiteId: null,
      currentStep: 1,
      isFirstTimeEnterXApiKey: true,
    }
  },

  watch: {
    isFetchingSiteOption(newValue, oldValue) {
      if (oldValue && !this.isFetchingSiteOption && this.isValidXApiKey) {
        this.currentStep = 2
      } else if (!this.isFetchingSiteOption) {
        this.currentStep = 1
      }
    },
  },

  mounted() {},

  methods: {
    clickSaveXApiKey() {
      localStorage.setItem("self-check-in-x-api-key", this.xApiKey)
      this.isFirstTimeEnterXApiKey = false
      this.$emit("onSaveXApiKeyToLocalStorage")
    },

    clickBackToSetXApiKey() {
      this.currentStep = 1
    },

    clickSelectSite() {
      localStorage.setItem(
        "self-check-in-selected-site-id",
        this.selectedSiteId
      )
      this.$emit("onSaveSelectedSiteIdToLocalStorage")
    },
  },
}
</script>

<style lang="scss" scoped>
.select-site-location-card,
.x-api-key-card {
  width: 600px;
}

.custom-input-width {
  width: 400px;
}

.custom-btn-width {
  width: 285px;
}

.custom-site-list-width {
  width: 440px;
}

.site-option-container {
  padding: 12px 0px;
  max-height: 355px;
  overflow-y: auto;
  > :first-child {
    margin-top: 0;
  }
}

.site-option-card {
  border: 1px solid #ecedee;
  border-radius: 6px;
  padding: 12px 16px;
  margin: 12px 0px;
  transition: color 0.25s linear, background-color 0.25s linear,
    border 0.1s linear;
  &:hover {
    cursor: pointer;
  }
}

.site-option-card--active {
  color: #7367f0;
  background-color: #f7f6fe;
  border: 1px solid #7367f0;
}
</style>
